import { OverlayModule } from '@angular/cdk/overlay'
import { Component, input, ChangeDetectionStrategy } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { MatTooltipModule } from '@angular/material/tooltip'
import { InfoComponent } from '../info/info.component'

/**
 * Ein Info-Icon-Button der einen Info-Text als Popover anzeigt
 * @see InfoComponent
 */
@Component({
  selector: 'lib-info-popover',
  imports: [OverlayModule, InfoComponent, MatIconModule, MatButtonModule, MatMenuModule, MatTooltipModule],
  templateUrl: './info-popover.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './info-popover.component.scss',
})
export class InfoPopoverComponent {
  readonly apperance = input<'small' | 'normal'>()
}
